import {SimplePageLayout} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {useMessages} from "../hooks/useMessages.ts";


export const AliasMessagesPage = () => {

    const {
        visibleItems,
    } = useMessages();

    return (
        <SimplePageLayout
            pageNavigation={<IndexPageNavigation/>}
            pageHeader={<IndexPageHeader/>}
        >
            <RecordsTable records={visibleItems}/>
        </SimplePageLayout>
    );
};
